/**
 * Adapptio Editor
 *
 * @package editor
 * @copyright 2021-2025 Hexio a.s. <contact@hexio.io> (hexio.io) and contributors.
 * @license Apache-2.0
 *
 * See LICENSE file distributed with this source code for more information.
 */

import { TGenericBlueprintSchema } from "@adapptio/lib-blueprint";
import { IInspectorControls } from "./InspectorTypes";

/**
 * Returns a default icon of a given schema
 *
 * @param schema Schema name
 * @param defaultIcon Default icon for unknown schemas
 */
export function getSchemaDefaultIcon(
	schema: TGenericBlueprintSchema,
	defaultIcon = "mdi/text-short"
): string {
	switch (schema?.name) {
		case "constBoolean": {
			return "mdi/checkbox-marked-outline";
		}
		case "constString": {
			return "mdi/text-short";
		}
		case "constInteger":
		case "constFloat": {
			return "mdi/numeric";
		}
		case "constEnum": {
			return "mdi/format-list-bulleted-type";
		}
		case "actionRef":
		case "viewRef":
		case "integrationRef": {
			return "mdi/link";
		}
		default: {
			switch (schema?.opts.editorOptions?.controlType) {
				case "colorSelector": {
					return "mdi/palette";
				}
				case "fontSizeSelector": {
					return "mdi/format-size";
				}
				default: {
					return defaultIcon;
				}
			}
		}
	}
}

/**
 * Returns if inspector controls contains any controls at all
 *
 * @param controls Inspector controls
 */
export function hasAnyInspectorControls(controls: IInspectorControls): boolean {
	return !!(
		controls.primary ||
		controls.primaryChildren ||
		controls.children ||
		controls.headerPrefix ||
		controls.headerControls
	);
}
